// extracted by mini-css-extract-plugin
module.exports = {"link":"Title_link__YxKXz","text":"Title_text__Spfs6"};